import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MdCheckboxModule, MdRadioModule} from '@angular/material';
import {RouterModule} from '@angular/router';
import {CustomFormsModule} from 'ng2-validation';
import {SharedModule} from '../../shared/shared.module';
import {RegisterComponent} from './register.component';
import {PasswordValidatorModule} from '../../shared/validators';

@NgModule({
  imports: [
    CommonModule,
    CustomFormsModule,
    FormsModule,
    MdCheckboxModule,
    MdRadioModule,
    RouterModule,
    SharedModule,
    PasswordValidatorModule,
  ],
  declarations: [RegisterComponent],
  exports: [RegisterComponent],
})
export class RegisterModule {}



// WEBPACK FOOTER //
// ./src/app/auth/register/register.module.ts